<!-- eslint-disable vue/multi-word-component-names -->
<!--
*  TTTech nerve-ui-components
*  Copyright(c) 2022. TTTech Industrial Automation AG.
*
*  ALL RIGHTS RESERVED.
*
*  Usage of this software, including source code, netlists, documentation,
*  is subject to restrictions and conditions of the applicable license
*  agreement with TTTech Industrial Automation AG or its affiliates.
*
*  All trademarks used are the property of their respective owners.
*
*  TTTech Industrial Automation AG and its affiliates do not assume any liability
*  arising out of the application or use of any product described or shown
*  herein. TTTech Industrial Automation AG and its affiliates reserve the right to
*  make changes, at any time, in order to improve reliability, function or
*  design.
*
*  Contact Information:
*  support@tttech-industrial.com
*
*  TTTech Industrial Automation AG, Schoenbrunnerstrasse 7, 1040 Vienna, Austria
*
* -->
<template>
  <div id="iiotLoginBackgroundImage" :style="{ 'background-image': 'url(' + image + ')' }" class="login-background">
    <img id="iiotLoginLogo" :src="logo" />
  </div>
</template>

<script>
export default {
  props: {
    logo: {
      type: String,
      default: '',
    },
    image: {
      type: String,
      default: '',
    },
  },
};
</script>

<style>
#iiotLoginLogo {
  margin-top: 30%;
  margin-left: 40%;
}

#iiotLoginBackgroundImage {
  width: 100%;
  background-size: cover;
  background-position-x: 99%;
  height: 100%;
}
</style>
